import { FC, useState } from 'react';
import { FOLDER_DIRECTORIES } from '../../../constants/folder';
import Routes from '../../../constants/routes';
import qualityEvents from '../../../services/quality-events/quality-events';
import cn from '../../../utils/classnames';
import FolderWizard from '../folder-wizard/folder-wizard';

type AddToFolderButtonProps = {
    children: React.JSX.Element;
    directory: FOLDER_DIRECTORIES;
    underlined?: boolean;
    onClickCallback?: () => void;
    onSuccessCallback?: () => void;
};

const CreateFolderButton: FC<AddToFolderButtonProps> = ({
    directory,
    children,
    underlined = true,
    onClickCallback,
    onSuccessCallback
}) => {
    const [showModal, setShowModal] = useState(false);

    const inFavoritesPage = window.location.pathname === Routes.FAVORITES.path;
    const handleCreation = inFavoritesPage ? qualityEvents.favoritesPage.createFavoritesList : undefined;

    const handleClick = () => {
        setShowModal(true);
        onClickCallback && onClickCallback();
    };
    const handleClose = () => setShowModal(false);

    return (
        <>
            <span className={cn('cursor-pointer', { 'text-underline': underlined })} onClick={handleClick}>
                {children}
            </span>
            {showModal && (
                <FolderWizard
                    directory={directory}
                    onClose={handleClose}
                    onCreate={handleCreation}
                    onSuccessCallback={onSuccessCallback}
                />
            )}
        </>
    );
};

export default CreateFolderButton;
